import { render, staticRenderFns } from "./OrganizationApplications.vue?vue&type=template&id=0bba8775&"
import script from "./OrganizationApplications.vue?vue&type=script&lang=ts&"
export * from "./OrganizationApplications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports